export const DEVICE_LOGIN_DETECTED = "device_login_detected";
export const DEVICE_MODAL_DELAY_MS = 250;
